import { localStorageService } from './localStorage/local-storage.service';
import LocalStorageKey from './localStorage/local-storage-key';
/**
 * 데모 모드 여부 확인
 * @returns 데모 모드이면 true, 아니면 false
 */
export const isDemoMode = () => {
    return localStorageService.getItem(LocalStorageKey.TRADE_MODE) === 'demo';
};
/**
 * 실거래 모드 여부 확인
 * @returns 실거래 모드이면 true, 아니면 false
 */
export const isRealMode = () => {
    return !isDemoMode();
};
//# sourceMappingURL=tradingMode.js.map